import React from "react";
import { Translate } from "components/common/Translate/Translate";
import dynamic from "next/dynamic";

const CropJpgFreeWithOnlineImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/CropJpg/CropJpgFreeWithOnlineImagePreviewImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

const CropJpgPerfectYourImageImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/CropJpg/CropJpgPerfectYourImageImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

export const CropJpgFreeWithOnline = ({image}: {image?:string}) => {
    return (
        <>
            <div className="flex flex-col md:flex-row items-center ">
                <div className="flex-1 gap-2 hidden md:block">
                    <CropJpgFreeWithOnlineImagePreview image={image} />
                </div>
                <div className="flex-1 dark:text-white text-center md:text-left">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="precise-cropping-title"/>
                    </h2>
      
                    <p className="md:pt-6 md:mt-1 mt-5">
                        <Translate keyName="precise-cropping-subtitle" />
                    </p>
                    <div className="flex-1 gap-2 md:hidden">
                    <CropJpgFreeWithOnlineImagePreview image={image} />
                    </div>
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 dark:text-white text-center md:text-left order-2 md:order-1">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="drag-adjust-title" />
                    </h2>
                    <p className="md:pt-6 md:mt-1 mt-5">
                        <Translate keyName="drag-adjust-subtitle" />
                    </p>
                    <div className="flex-1 gap-2 md:hidden">
                        <CropJpgPerfectYourImageImagePreview image={image} />
                    </div>
                </div>
                <div className="flex-1 gap-2 hidden md:block order-1 md:order-2">
                    <CropJpgPerfectYourImageImagePreview image={image} />
                </div>
            </div>
        </>
    )
};

